import { render, staticRenderFns } from "./developSmtProtocol.vue?vue&type=template&id=2fb9a694&scoped=true"
import script from "./developSmtProtocol.vue?vue&type=script&lang=js"
export * from "./developSmtProtocol.vue?vue&type=script&lang=js"
import style0 from "./developSmtProtocol.vue?vue&type=style&index=0&id=2fb9a694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9a694",
  null
  
)

export default component.exports